import { Injectable } from "@angular/core";
import { CapacitorCalendar, EventSpan, PluginPermission } from "@ebarooni/capacitor-calendar";
import { isPlatform } from "@ionic/angular";
import { AppointmentDto } from "src/app/calendar/interfaces/appointment_dto";

@Injectable({
    providedIn: "root",
})
export class LocalCalendarService {

    async checkPermissions() {
        const readStatus = await CapacitorCalendar.checkPermission({ alias: PluginPermission.READ_CALENDAR });
        const writeStatus = await CapacitorCalendar.checkPermission({ alias: PluginPermission.WRITE_CALENDAR });

        if (readStatus.result === "granted" && writeStatus.result === "granted") {
            return true;
        }
        return false;
    }

    async requestPermissions() {
        if (await this.checkPermissions()) {
            return true;
        }
        const status = await CapacitorCalendar.requestAllPermissions();

        if (status.readWriteCalendar === "granted" || (status.readCalendar === "granted" && status.writeCalendar === "granted")) {
            return true;
        }
        return false;
    }
    
    async getLocalCalendars() {
        if (!isPlatform("capacitor")) {
            return [];
        }
        const calendars = await CapacitorCalendar.listCalendars();
        return calendars.result;
    }

    async getLocalEvents(calendarId: string) {
        if (!isPlatform("capacitor")) {
            return [];
        }
        var startDate = new Date();
        var startDateCopy = new Date(startDate.setDate(startDate.getDate() - 60));
        var timeMin = startDateCopy.getTime();
    
        var endDate = new Date();
        var endDateCopy = new Date(endDate.setDate(endDate.getDate() + 240));
        var timeMax = endDateCopy.getTime();

        const events = await CapacitorCalendar.listEventsInRange({startDate: timeMin, endDate: timeMax});
        const localEvents =  events.result.filter(
            (item) => item.calendarId === calendarId
        )

        const appointments = localEvents.map(((item) => {
            return {
                Id: item.id as any,
                Subject: item.title,
                Description: item.description,
                Location: item.location,
                StartTime: new Date(item.startDate),
                EndTime: new Date(item.endDate),
                IsAllDay: item.isAllDay,
                ResourceId: item.calendarId,
                IsReadOnly: true,
                LocalCalendarId: item.id
            }
        })) as Partial<AppointmentDto>[];

        const filteredAppointments = appointments.filter(appointment => !appointment?.Description?.includes("app.quickdrive.ch"));

        return filteredAppointments as AppointmentDto[];
    }

    async createLocalCalendar() {
        const calendar = await CapacitorCalendar.createCalendar({
            title: "quickdrive",
            color: "#0054e9",
            sourceId: "quickdrive",
        });
        return calendar.result;
    }

    async createLocalEvent(event: any) {
        const newEvent = await CapacitorCalendar.createEvent({
            title: event.title,
            location: event.location,
            startDate: event.startDate,
            endDate: event.endDate,
            url: "app.quickdrive.ch",
        });
        return newEvent.result;
    }

    async updateLocalEvent(eventId: string, event: any) {
        const updatedEvent = await CapacitorCalendar.modifyEvent({
            id: eventId,
            span: EventSpan.THIS_EVENT,
            update: {
                title: event.title,
                startDate: event.startDate,
                endDate: event.endDate,
                isAllDay: false,
            },
        });

        return updatedEvent;
    }

    async deleteLocalEvent(eventId: string) {
        const deletedEvent = await CapacitorCalendar.deleteEventsById({
            ids: [eventId],
        });
        return deletedEvent;
    }
}